module.exports = __webpack_public_path__ + "img/tree-02-e-leaves.a85781b3.png";